import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data1 from "../../Data/researchData1.json";
import data2 from "../../Data/researchData2.json";

export default function Research() {
  return (
    <section className="licenses antiCorruption research">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Научно-исследовательские разработки
      </h1>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Научные прикладные исследования в соответствии с Государственным
          заданием:
        </h3>
        {/* <div className="licenses__table"> */}
        <div className="licenses__blank research__blank">
          <h4 className="directions__more-title licenses__text research__text">
            <li>
              Иммунологические, биохимические и патоморфологические основы
              развития системного воспаления и его влияние в формировании
              субстрата заболевания у больных аллергическими, аутоиммунными,
              пролиферативными дерматозами и периферическими лимфомами кожи
              (регистрационный номер 115060840024).
            </li>
          </h4>
          <h4 className="directions__more-title licenses__text research__text">
            <li>
              Разработка новых наружных средств комплексного действия для
              реабилитации кожи у больных хроническими дерматозами в
              межрецидивный период (регистрационный номер 115060840027).
            </li>
          </h4>
          <h4 className="directions__more-title licenses__text research__text">
            <li>
              Мишень-направленный поиск фармакологически активных
              антибактериальных и антимикотических вновь синтезированных
              химических соединений, перспективных для разработки отечественных
              импортзамещающих лекарственных препаратов для лечения наиболее
              распространенных и социально значимых инфекций (регистрационный
              номер 115060840028).
            </li>
          </h4>
          <h4 className="directions__more-title licenses__text research__text">
            <li>
              Совершенствование специфической диагностики, лечения и мониторинга
              эффективности терапии сифилитической инфекции на основе изучения
              общих иммунологических и патофизиологических закономерностей
              инфекционного процесса, фармакокинетических свойств
              антибактериальных препаратов и персональных характеристик пациента
              (регистрационный номер 115060840025).
            </li>
          </h4>
          <h4 className="directions__more-title licenses__text research__text">
            <li>
              Разработка новых организационных технологий противоэпидемической и
              профилактической работы по снижению заболеваемости сифилисом, в
              том числе детей дошкольного и младшего школьного возраста,
              врожденным сифилисом, профилактике и своевременной диагностике
              поздних форм сифилиса, в том числе с поражением нервной системы
              (регистрационный номер 115060840026).
            </li>
          </h4>
          {/* </div> */}
        </div>

        <div>
          <h3 className="about-nii__title antiCorruption__title">Приказы</h3>

          <Accordion data={data1} />
        </div>

        <div>
          <h3 className="about-nii__title antiCorruption__title">
            Методические рекомендации
          </h3>

          <Accordion data={data2} />
        </div>
      </div>
    </section>
  );
}
